import { placeholders } from '../helpers/placeholders';
/**
 * Creates element from template.
 * @param template String template
 * @param data Any data object to bind to template
 * @param translations Basket translations
 */
export var createElement = function (template, data, translations) {
    var shadowElement = document.createElement('div');
    shadowElement.innerHTML = placeholders(template, data, translations);
    return shadowElement.children[0];
};
